<div
  *ngIf="content.hasError || content.isSuccess"
  class="form-alert"
  id="formAlertId"
>
  <idp-form-alert
    [message]="content.errorMessage"
    [successIcon]="content.isSuccess"
    [showCloseButton]="true"
    (closePopup)="onClosePopup()"
  ></idp-form-alert>
</div>
<idp-login-header
  [ngClass]="{
    'login-header-margin':
      content.formAttributes.errorAlertBanner &&
      content.formAttributes.submitAttempt
  }"
  [loginHeaderContent]="content.pageContent.pageHeader"
></idp-login-header>
<ng-container
  *ngIf="
    content.formAttributes.submitAttempt &&
    content.formAttributes.errorAlertBanner &&
    content.formAttributes.errorCount
  "
>
  <idp-alert-warning
    #alertWarning
    (firstInvalidFieldFocusEvent)="onFocusFirstInvalidField()"
    [cntError]="content.formAttributes.errorCount"
    [errorMessage]="content.pageContent.errors.alertWarning"
  ></idp-alert-warning>
</ng-container>
<form
  [formGroup]="addAddressForm"
  id="addAddressForm"
  class="add-address"
  (ngSubmit)="onSubmit()"
>
  <div class="add-address__content">
    <div class="add-address__content__country">
      <idp-dropdown
        [items]="content.pageContent.countryList"
        [topLabelText]="content.pageContent.countryLabel"
        formControlName="country"
        id="country"
        (value)="onCountryChange($event)"
      ></idp-dropdown>
      <div *ngIf="showErrorMessageCountry" class="error-message__country">
        <span
          class="errorMessageText"
          [innerHTML]="content.pageContent.countryErrorMessage"
        ></span>
      </div>
    </div>
    <div
      *ngIf="getAddressLine('addressLine1').visible"
      class="add-address__content__address-line-one"
    >
      <idp-input
        [labelTxt]="getAddressLine('addressLine1').label"
        [ariaLabel]="getAddressLine('addressLine1').label"
        formControlName="addressLine1"
        id="addressLine1"
        (value)="onChange()"
        (focusOut)="onFocussedOut('addressLine1')"
      ></idp-input>
      <div
        *ngIf="showErrorMessageAddressLineOne"
        class="error-message__address-line-one"
      >
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.addressLine1ErrorMessage[
              addressLineOneFormControl().errors.error
            ]
          "
        ></span>
      </div>
    </div>
    <div
      *ngIf="getAddressLine('addressLine2').visible"
      class="add-address__content__address-line-two"
    >
      <idp-input
        [labelTxt]="getAddressLine('addressLine2').label"
        [ariaLabel]="getAddressLine('addressLine2').label"
        formControlName="addressLine2"
        id="addressLine2"
        (value)="onChange()"
        (focusOut)="onFocussedOut('addressLine2')"
      ></idp-input>
      <div
        *ngIf="showErrorMessageAddressLineTwo"
        class="error-message__address-line-two"
      >
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.addressLine2ErrorMessage[
              addressLineTwoFormControl().errors.error
            ]
          "
        ></span>
      </div>
    </div>
    <div
      *ngIf="getAddressLine('addressLine3').visible"
      class="add-address__content__district"
    >
      <idp-input
        [labelTxt]="getAddressLine('addressLine3').label"
        [ariaLabel]="getAddressLine('addressLine3').label"
        formControlName="district"
        id="'district'"
        (value)="onChange()"
        (focusOut)="onFocussedOut('district')"
      ></idp-input>
      <div *ngIf="showErrorMessageDistrict" class="error-message__district">
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.districtErrorMessage[
              districtFormControl().errors.error
            ]
          "
        ></span>
      </div>
    </div>
    <div
      *ngIf="getAddressLine('addressLine4').visible"
      class="add-address__content__city"
    >
      <idp-input
        [labelTxt]="getAddressLine('addressLine4').label"
        [ariaLabel]="getAddressLine('addressLine4').label"
        formControlName="city"
        id="city"
        (value)="onChange()"
        (focusOut)="onFocussedOut('city')"
      ></idp-input>
      <div *ngIf="showErrorMessageCity" class="error-message__city">
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.cityErrorMessage[
              cityFormControl().errors.error
            ]
          "
        ></span>
      </div>
    </div>
    <div
      *ngIf="getAddressLine('addressLine6').visible"
      class="add-address__content__address-line6"
    >
      <idp-input
        [labelTxt]="getAddressLine('addressLine6').label"
        [ariaLabel]="getAddressLine('addressLine6').label"
        formControlName="addressLine6"
        id="addressLine6"
        (value)="onChange()"
        (focusOut)="onFocussedOut('addressLine6')"
      ></idp-input>
    </div>
    <div class="stateZipDiv">
      <div class="d-flex flex-row align-items-end">
        <div
          *ngIf="
            getAddressLine('addressLine7').visible ||
            getAddressLine('addressLine5').visible
          "
          class="add-address__content__state pl-0 col-8"
        >
          <idp-dropdown
            [items]="content.pageContent.stateList"
            [placeholderText]="content.pageContent.defaultStateSelectValue"
            [topLabelText]="content.pageContent.stateLabel"
            formControlName="state"
            (hasFocus)="onFocussedOut('state')"
            (value)="onChange()"
            id="state"
          ></idp-dropdown>
        </div>
        <div
          *ngIf="getAddressLine('addressLine9').visible"
          class="add-address__content__postal-code"
        >
          <idp-input
            [labelTxt]="getAddressLine('addressLine9').label"
            [ariaLabel]="getAddressLine('addressLine9').label"
            formControlName="postalCode"
            id="postalCode"
            (value)="onChange()"
            (focusOut)="onFocussedOut('postalCode')"
          ></idp-input>
        </div>
      </div>
      <div *ngIf="showErrorMessageState" class="error-message__state">
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.stateErrorMessage[
              stateFormControl().errors.error
            ]
          "
        ></span>
      </div>
      <div
        *ngIf="showErrorMessagePostalCode"
        class="error-message__postal-code"
      >
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.postalCodeErrorMessage[
              postalCodeFormControl().errors.error
            ]
          "
        ></span>
      </div>
    </div>
  </div>
  <div class="add-address__submit-btn">
    <idp-button
      [label]="content.pageContent.buttonLabel"
      [ariaLabel]="content.pageContent.buttonLabel"
      elementType="submit"
      [size]="'full-width'"
      [disabled]="content.formAttributes.disableActionButton"
    ></idp-button>
  </div>
</form>
